import React, { useEffect, useState } from "react";
import { Tab, Nav } from 'react-bootstrap';
import { useDispatch } from 'react-redux'
import { toast } from "react-toastify";
import * as HELPER from "@src/config/helper";
import FullPageLoader from '@src/common/FullPageLoader';
import InsuranceListTable from '@src/pages/insurance/list/InsuranceListTable';
import {getClaimList } from '@src/store/slices/insurance';
import { APP_TYPE_AGENCY, DEFAULT_PAGE_NO, STATUS_CODES } from "@src/config/constant";



function ClaimList() {
    const dispatch: any = useDispatch();
    // const insuranceState = useSelector((state: any) => state.insurance);
    // const commonState = useSelector((state: any) => state.common);
    const [loading, setLoading] = useState<boolean>(false);
    const [insuranceList, setInsuranceList] = useState<any>([]);
    const [paginationData, setPaginationData] = useState<any>({});
    // eslint-disable-next-line
    const [selectedFilters, setSelectedFilters] = useState<any>({ page_number: 1,apptype:4,lead_type:5,type:"claim"});
    // const [listSort, setListSort] = useState<any>({});
    


    const [searchKeyword, setSearchKeyword] = useState<string>('');

    useEffect(() => {
        getInsuranceListing({});
    // eslint-disable-next-line
    }, []);


    const handleSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            const trimmedKeyword = searchKeyword.trim();
            setSearchKeyword(trimmedKeyword);
            getInsuranceListing({searchKey : HELPER.EncodetoBase64(trimmedKeyword)});
        }
    };

    // useEffect(() => {

    //     let updatedSelctedFilters: any = {...selectedFilters};

    //     if (searchKeywordParam) {
    //         updatedSelctedFilters['searchKeyword'] = searchKeywordParam;
    //     }

    //     if (statusParam) {
    //         updatedSelctedFilters['status_id_arr'] = statusParam.split(",").map((v: any) => +v);
    //     }

    //     if (subStatusParam) {
    //         updatedSelctedFilters['sub_status_id_arr'] = subStatusParam.split(",").map((v: any) => +v);
    //     }

    //     if (filterTypeParam) {
    //         updatedSelctedFilters['filterType'] = filterTypeParam;
    //     }

    //     if (!searchKeywordParam && !statusParam && !subStatusParam) {
    //         updatedSelctedFilters = { page_number: selectedFilters.page_number, activeTab: selectedFilters.activeTab };
    //     } else {

    //         setSelectedFilters((prev: any) => { return { ...prev, ...updatedSelctedFilters }; });
    //     }

    //     getInsuranceListing(updatedSelctedFilters);

    //     // eslint-disable-next-line
    // }, [searchKeywordParam, statusParam, subStatusParam])

    // useEffect(() => {
    //     if (Object.keys(insuranceState.insuranceListFilters).length) {
    //         setSelectedFilters({ ...insuranceState.insuranceListFilters });
    //     }
    // }, [insuranceState])

    //GET INSURANCE LIST API
    const getInsuranceListing = (params: any) => {
        let filters = {
            // status_type:"submitted",
            apptype:APP_TYPE_AGENCY,
            lead_type:5,
            type:"claim",
            ...params,
            page_number: params?.page_number ?? DEFAULT_PAGE_NO,
        }

        if (filters['dateType']) {
            let errorFilter = false;
            if (!filters['from_date'] && !filters['to_date']) {
                errorFilter = true;
                toast.error("From Date and To Date are required");
            } else if (filters['from_date'] && filters['to_date'] && new Date(filters['from_date']).getTime() > new Date(filters['to_date']).getTime()) {
                errorFilter = true;
                toast.error("To Date should be greater than From Date");
            }

            if (errorFilter) return false;
        }

        // dispatch(leadListFilters(filters));

        setLoading(true);
        // for searching customer as encrypt and then decrypt backend
        let modifiedFilters = { ...filters };

        // if (params?.searchKeyword) {
        //     modifiedFilters.searchKeyword = HELPER.EncodetoBase64(params?.searchKeyword);
        // }
        dispatch(getClaimList(modifiedFilters)).then((res: any) => {
            setLoading(false)
            if (res && res.status === STATUS_CODES['success']) {
                setPaginationData({ ...res.pagination })
                setInsuranceList([])
                setInsuranceList([...res.data])
            }
        }).catch((err: Error) => {
            setLoading(false)
        })
    }

    const activeTabHandler = (tab: any) => {
        if (tab === "third") {
            getInsuranceListing({ ...selectedFilters, page_number: DEFAULT_PAGE_NO, status_type: "pending_payment" })
        } else if (tab === "fourth") {
            getInsuranceListing({ ...selectedFilters, page_number: DEFAULT_PAGE_NO, status_type: "pending" })
        } else if (tab === "first") {
            getInsuranceListing({ ...selectedFilters, page_number: DEFAULT_PAGE_NO })
        } else if (tab === "second") {
            getInsuranceListing({ ...selectedFilters, page_number: DEFAULT_PAGE_NO, status_type: "policy_issued" })
        }
    }

    // const handleSeeMoreClick = () => {
    //     let seeMore: any = document.getElementsByClassName('username-see-more')?.[0]
    //     //disable old Li elements
    //     if (seeMore.textContent === `- ${selectedFilters['username']?.length - 5} more`) {
    //         let documents: any = document.getElementsByClassName('to-hide')
    //         seeMore.textContent = `+ ${selectedFilters['username']?.length - 5} more`

    //         while (documents?.length) {
    //             documents[0].classList.add("hide");
    //             documents[0].classList.remove("to-hide");
    //         }

    //     } else {
    //         //enable hidden Li elements
    //         let documents: any = document.getElementsByClassName('hide')
    //         seeMore.textContent = `- ${selectedFilters['username']?.length - 5} more`

    //         while (documents?.length) {
    //             documents[0].classList.add("to-hide");
    //             documents[0].classList.remove("hide");
    //         }

    //     }
    // }

    /**
     * SORT LIST
     * @param event 
     */
    // const sortByhandleChange = (event: any) => {
    //     setListSort({});
    //     if (event['value']) {
    //         getInsuranceListing({ ...selectedFilters, sortBy: event, page_number: 1 });
    //         setListSort(event)
    //     }
    // }

    // const updateUrl = (filterKey: string) => {
    //     if(filterKey === 'resetAll'){
    //         if(searchParams.size){

    //             searchParams.delete('status_id_arr');
    //             searchParams.delete('sub_status_id_arr');
    //             searchParams.delete('filterType');
    //             searchParams.delete('searchKeyword');
    //             delete selectedFilters['status_id_arr'];
    //             delete selectedFilters['sub_status_id_arr'];
    //             delete selectedFilters['searchKeyword'];
    //             delete selectedFilters[filterKey];

    //             setSearchParams(searchParams);
    //             setSelectedFilters(selectedFilters);

    //             getInsuranceListing({activeTab: selectedFilters.activeTab || undefined});

    //         }else{

    //             getInsuranceListing({activeTab: selectedFilters.activeTab || undefined});

    //         }
    //     }else{
    //         //REMOVE FROM URL
    //         searchParams.delete(filterKey);
    //         delete selectedFilters[filterKey];
    //         setSearchParams(searchParams);
    //         setSelectedFilters(selectedFilters);
    //     }
    // }

    // const updateListFromChlid = (filterParams: any) => {
    //     getInsuranceListing(filterParams);

    // }

    // const handleExport = async () => {
    //     setLoading(true)
    //     const filterParams = insuranceState?.insuranceListFilters || { page_number: 1 }
    //     const exportData: any = await exportInsuranceData(filterParams)
    //     setLoading(false)

    //     if(exportData?.status === 200 && exportData.message) {
    //         toast.success(exportData.message)
    //     } else {
    //         toast.error("Error Occured")
    //     }
    // }


    return (
        <React.Fragment>
            <FullPageLoader show={loading} />
            <div className="container-fluid wap-bg-white">
                <div className="agent-top-heading agent-lead-heding insurance-top-filer-heading p-lg-t">
                    <h1>Claim Insurance</h1>
                </div>
                <div className="agent-filter-bg">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                        <Nav variant="pills" className="flex-column tab-line nav nav-pills" onSelect={(k) => activeTabHandler(k)}>
                            <div className="tab-list top-filter-bg claim-insurnce-search">
                                <div className="search-bx mb-2">
                                    <div className="material" title="Search by anything">
                                    <input type="text" placeholder="Search by anything" aria-label="Search text" value={searchKeyword} onChange={(e) => setSearchKeyword(e.target.value)} onKeyDown={(e) => handleSearch(e)}/>
                                    <i className="ic-search"></i>
                                    </div>
                                </div>
                            </div>
                        </Nav>


                        <Tab.Content>
                            <Tab.Pane eventKey="first">
                                <InsuranceListTable 
                                insuranceList={insuranceList} 
                                paginationData={paginationData} 
                                getInsuranceListing={getInsuranceListing} selectedFilters={selectedFilters} />

                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </div> 
        </React.Fragment>
    )
}

export default ClaimList;